import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import apiClient from "../../api/client";
import { UserContext } from "../UserContext";
import Header from "../Header";
import PackDetails from "../PackDetails";
import ConfirmModal from "./ConfirmModal";
import ChangeBasePlanModal from "./ChangeBasePlanModal";
import ComboPlansModal from "./ComboPlansModal";
import PlanCard from "./PlanCard";
import { toast } from "react-toastify";
import PioneerPlanCard from "./PioneerPlanCard";
import InternetPlanCard from "./InternetPlanCard";
import VerificationModal from "./VerificationModal";
import InternetRechargeModal from "./InternetRechargeModal";
import VerifyAadhaarModal from "./VerifyAadhaarModal";
import CustomerTransactionHistory from "./CustomerTransactionHistory";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button
} from "@mui/material";
import "./index.css";
import RemoveMacModal from "./RemoveMacModal";
import PasswordModal from "./PasswordModal";
import SessionHistoryModal from "./SessionHistoryModal";
import RailtelPlanCard from "./RailtelPlanCard";
import RailtelRechargeModal from "./RailtelRechargeModal";
import RailtelSessionHistoryModal from "./RailtelSessionHistoryModal";
import { railtelGetLinkedAccounts, railtelLinkAccount, railtelUnlinkAccount, railtelLookupByUsername, railtelGetOnlineStatus } from "../../api/railtelApi";
import OperatorSearchSelect from "../OperatorSearchSelect";

const Customer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, token } = useContext(UserContext);
  const internetEnabled = user?.internetEnabled;
  const railtelEnabled = user?.railtelEnabled;
  const role = user.role;

  const [customer, setCustomer] = useState(null);
  const [operator, setOperator] = useState(null);
  const [operators, setOperators] = useState([]);
  const [basePlan, setBasePlan] = useState(null);
  const [addons, setAddons] = useState([]);
  const [allPackDetails, setAllPackDetails] = useState([]);
  const [mappedAddons, setMappedAddons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [devices, setDevices] = useState([]);
  const [deviceType, setDeviceType] = useState("normal");
  const [stelfiberDevices, setStelfiberDevices] = useState([]);
  const [devicesModalVisible, setDevicesModalVisible] = useState(false);
  const [selectedUserForDevices, setSelectedUserForDevices] = useState(null);
  const [showEditForm, setShowEditForm] = useState(false);
  const [assignDevices, setAssignDevices] = useState([]);
  const [showAssign, setShowAssign] = useState(false);

  const [assignLoading, setAssignLoading] = useState(false);
  const [assignSearch, setAssignSearch] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showUsernamePassword, setShowUsernamePassword] = useState(false);
  const [actionLoading, setActionLoading] = useState(null);
  const [renewCooldown, setRenewCooldown] = useState({});
  const [comboModal, setComboModal] = useState(false);
  const [visiblePackages, setVisiblePackages] = useState({});
  // True only once fetchVisiblePackages has actually returned for this
  // customer — see its use in the default-tab-pick effect below.
  const [visiblePackagesLoaded, setVisiblePackagesLoaded] = useState(false);

  const [showInternetRecharge, setShowInternetRecharge] = useState(false);
  const [internetRechargeAdvance, setInternetRechargeAdvance] = useState(false);
  const [showSessionHistory, setShowSessionHistory] = useState(false);
  const [showRemoveMac, setShowRemoveMac] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showVerifyAadhaar, setShowVerifyAadhaar] = useState(false);

  // DVPL — same OneRADIUS-style account as Internet, tracked with its
  // own parallel set of modal/loading state since a customer can have
  // one Internet account AND one DVPL account linked at the same time.
  const [showDvplRecharge, setShowDvplRecharge] = useState(false);
  const [dvplRechargeAdvance, setDvplRechargeAdvance] = useState(false);
  const [showDvplSessionHistory, setShowDvplSessionHistory] = useState(false);
  const [showDvplRemoveMac, setShowDvplRemoveMac] = useState(false);
  const [showDvplPasswordModal, setShowDvplPasswordModal] = useState(false);
  const [showDvplVerifyAadhaar, setShowDvplVerifyAadhaar] = useState(false);
  const [showDvplVerification, setShowDvplVerification] = useState(false);

  const [railtelLinkedAccounts, setRailtelLinkedAccounts] = useState([]);
  const [railtelSubscribers, setRailtelSubscribers] = useState([]);
  const [selectedRailtelSubscriber, setSelectedRailtelSubscriber] = useState(null);
  const [railtelOnline, setRailtelOnline] = useState(false);
  const [railtelLoading, setRailtelLoading] = useState(false);
  const [railtelRefreshLoading, setRailtelRefreshLoading] = useState(false);
  const [railtelOnlineLoading, setRailtelOnlineLoading] = useState(false);
  const [railtelLookedUp, setRailtelLookedUp] = useState(false);
  const [showRailtelRecharge, setShowRailtelRecharge] = useState(false);
  const [showRailtelSessionHistory, setShowRailtelSessionHistory] = useState(false);
  // "Add RailTel Account" — only relevant while under the 2-account cap.
  const [showAddRailtelAccount, setShowAddRailtelAccount] = useState(false);
  const [newRailtelUsername, setNewRailtelUsername] = useState("");
  const [addingRailtelAccount, setAddingRailtelAccount] = useState(false);

  const [activePlanTab, setActivePlanTab] = useState(null);
  // Raw per-provider lookup info from sync_user_plans.php (status/desc, not just expiry)
  const [pioneerIptvInfo, setPioneerIptvInfo] = useState(null);

  // Raw lookup payload for the customer's Internet/Broadband (OneRADIUS)
  // account. Same idea as pioneerIptvInfo — { status, results } — used to
  // tell "not linked yet" apart from "linked, here are the details".
  const [internetAccounts, setInternetAccounts] = useState([]);
  const [selectedInternetAccount, setSelectedInternetAccount] = useState(null);
  const [internetInfo, setInternetInfo] = useState(null);
  const [internetLoading, setInternetLoading] = useState(false);
  const [internetActionLoading, setInternetActionLoading] = useState(false);

  // Same idea, DVPL's own account — identical shape, kept fully
  // separate from the Internet state above rather than reusing it,
  // since a customer can have both linked simultaneously.
  const [dvplAccounts, setDvplAccounts] = useState([]);
  const [selectedDvplAccount, setSelectedDvplAccount] = useState(null);
  const [dvplInfo, setDvplInfo] = useState(null);
  const [dvplLoading, setDvplLoading] = useState(false);
  const [dvplActionLoading, setDvplActionLoading] = useState(false);

  const [addUserLoading, setAddUserLoading] = useState(false);
  const [pioneerAddUserError, setPioneerAddUserError] = useState(null);
  const [showVerification, setShowVerification] = useState(false);
  const [showAddPioneerUserDialog, setShowAddPioneerUserDialog] = useState(false);

  const [pioneerStbs, setPioneerStbs] = useState([]);
  const [pioneerRemoveStbLoading, setPioneerRemoveStbLoading] = useState(false);
  const [selectedStb, setSelectedStb] = useState(null);
  const [advanceRecharge, setAdvanceRecharge] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showRechargeDialog, setShowRechargeDialog] = useState(false);
  const [pioneerBranches, setPioneerBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [pioneerBranchesLoading, setPioneerBranchesLoading] = useState(false);
  const [activeProvider, setActiveProvider] = useState(() => {
    try {
      return sessionStorage.getItem(`customer_${id}_tab`) || "";
    } catch {
      return "";
    }
  });
  const [defaultTabPicked, setDefaultTabPicked] = useState(() => {
    try {
      return !!sessionStorage.getItem(`customer_${id}_tab`);
    } catch {
      return false;
    }
  });

  const selectProviderTab = (key) => {
    setActiveProvider(key);
    setDefaultTabPicked(true);
    // Written synchronously, unlike the URL param — this is what makes
    // the tab survive even if something forces a full remount (a hard
    // reload/redirect somewhere, for instance), since it's read back in
    // the useState initializer above BEFORE any async data has had a
    // chance to load. The URL-based restore alone has a real gap: on a
    // fresh mount, the very first time the auto-pick effect runs,
    // visiblePackages is still empty, so even a correct ?tab=watcho in
    // the URL fails its check and falls through to the priority-order
    // default.
    try {
      sessionStorage.setItem(`customer_${id}_tab`, key);
    } catch {
      // Can throw in some private-browsing modes — the URL-based
      // restore still works as a fallback either way.
    }
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("tab", key);
      return next;
    }, { replace: true });
  };

  const pioneerHasStb = pioneerStbs.length > 0;

  const isPioneerStbActive = (stb) => {
    if (!stb?.expiration) return false;
    return new Date(stb.expiration) >= new Date();
  };

  const getPioneerStbPackageName = (stb) => {
    const plans = Array.isArray(stb?.plans) ? stb.plans : [];
    if (plans.length === 0) return null;

    const names = plans
      .map((p) => p?.prdname || p?.planName || p?.name || p?.pkgname)
      .filter(Boolean);

    return names.length > 0 ? names.join(", ") : null;
  };

  const pioneerPlanOptions = allPackDetails.filter(
    (p) => p.plan_category === "pioneeriptv" || p.category === "pioneeriptv"
  );

  const [allowedPlans, setAllowedPlans] = useState({
    watcho: [],
    playboxtv: [],
    antiptv: [],
    pioneeriptv: [],
    etvwin: []
  });

  const [confirmModal, setConfirmModal] = useState({
    open: false,
    type: null
  });

  const [expiryData, setExpiryData] = useState({
    vrplay: null,
    watcho: null,
    playboxtv: null,
    antiptv: null,
    pioneeriptv: null,
    etvwin: null,
    internet: null,
    dvpl: null
  });

  const [expiryLoading, setExpiryLoading] = useState(false);

  const [editForm, setEditForm] = useState({
    username: '',
    password: '',
    name: '',
    lastName: '',
    MobileNumber: '',
    EmailId: '',
    address: '',
    operatorDetails:
      role === "operator"
        ? `${user.operatorName || ''} - ${user.phoneNumber || ''}`
        : role === "admin"
          ? `${user.operatorName || ''} - ${user.operatorPhoneNumber || ''}`
          : "",  // superadmin chooses later
    autoplay: 'on',
    operatorId:
      role === "operator"
        ? user.operatorId
        : role === "admin"
          ? user.operatorId
          : "",
    remarks: ''
  });

  const [plansData, setPlansData] = useState({
    vrplay: null,
    watcho: null,
    playboxtv: null,
    antiptv: null,
    pioneeriptv: null,
    etvwin: null
  });

  const [searchParams, setSearchParams] = useSearchParams();

  const internetId = searchParams.get("internet");
  const dvplId = searchParams.get("dvpl");

  useEffect(() => {
    if (!customer || allPackDetails.length === 0) return;

    const vrplay = allPackDetails.find(
      p => Number(p.id) === Number(customer.vrplay_planId)
    );

    const watcho = allPackDetails.find(
      p => Number(p.id) === Number(customer.watcho_planId)
    );

    const playboxtv = allPackDetails.find(
      p => Number(p.id) === Number(customer.playboxtv_planId)
    );

    const antiptv = allPackDetails.find(
      p => Number(p.id) === Number(customer.antiptv_planId)
    );

    const pioneeriptv = allPackDetails.find(
      p => Number(p.id) === Number(customer.pioneeriptv_planId)
    );

    const etvwin = allPackDetails.find(
      p => Number(p.id) === Number(customer.etvwin_planId)
    );

    setPlansData({
      vrplay: vrplay || null,
      watcho: watcho || null,
      playboxtv: playboxtv || null,
      antiptv: antiptv || null,
      pioneeriptv: pioneeriptv || null,
      etvwin: etvwin || null
    });

  }, [customer, allPackDetails]);


  // isBackgroundRefresh=true skips the full-page skeleton entirely —
  // used by every recharge/change-plan/edit success handler, which were
  // all calling this with the default (skeleton-showing) behavior even
  // though the page was already fully rendered. That's what caused the
  // whole page — profile card, tabs, everything — to blank out and
  // rebuild from scratch after every single action, which is a large
  // part of what made this feel broken even once the tab-switch bug
  // itself is fixed: the visual "everything just reset" impression was
  // real, even on actions where the active tab technically stayed correct.
  const fetchCustomer = async (isBackgroundRefresh = false) => {
    try {
      if (!isBackgroundRefresh) {
        setLoading(true);
      }

      const { data } = await apiClient.get(
        `/customer/get_customer_full_details.php?id=${id}`
      );

      setCustomer(data.customer);
      setBasePlan(data.base_plan);
      setAddons(data.addons || []);
    } catch (err) {
      setError(err.response?.data?.error || err.message || "Failed");
      toast.error("Failed to load customer");
    } finally {
      if (!isBackgroundRefresh) {
        setLoading(false);
      }
    }
  };

  const fetchOperator = async () => {
    if (!customer?.operatorId) return;

    try {
      const { data } = await apiClient.get(
        `/operator_api.php?id=${customer.operatorId}`
      );

      setOperator(data.operator);
    } catch {
      toast.error("Failed to load operator");
    }
  };

  const fetchOperators = async () => {
    try {
      const { data } = await apiClient.get('/operator_api.php');
      setOperators(data.operators);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Network error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (role !== "operator") {
      fetchOperators();
    }
  }, [role]);

  const fetchAllPackages = async () => {
    try {
      const { data } = await apiClient.get(
        "/get_operator_allplans_with_apps.php"
      );

      setAllPackDetails(data || []);
    } catch {
      toast.error("Failed to load plans");
    }
  };

  useEffect(() => {
    fetchCustomer();
    fetchAllPackages();
  }, []);

  useEffect(() => {
    if (customer) fetchOperator();
  }, [customer]);


  useEffect(() => {
    if (addons.length > 0 && allPackDetails.length > 0) {
      const mapped = addons.map((addon) => {
        const full = allPackDetails.find(
          (p) => Number(p.id) === Number(addon.plan_id)
        );

        return {
          ...(full || {}),
          ...addon,
        };
      });

      setMappedAddons(mapped);
    }
  }, [addons, allPackDetails]);

  const loadInternetCustomer = async (accountId) => {
    try {

      setInternetLoading(true);

      const { data } = await apiClient.get(
        `/customer/internet_customer_details.php?id=${accountId}`
      );

      if (data.status === 200) {

        setSelectedInternetAccount(accountId);

        setInternetInfo(data);

      } else {

        toast.error("Unable to load Internet details");

      }

    } catch (err) {

      toast.error("Failed to load Internet account");

    } finally {

      setInternetLoading(false);

    }
  };

  // Identical to loadInternetCustomer — internet_customer_details.php
  // is row-scoped, so it reads the account's own `provider` column and
  // returns the right (DVPL) data without needing a type param here.
  const loadDvplCustomer = async (accountId) => {
    try {

      setDvplLoading(true);

      const { data } = await apiClient.get(
        `/customer/internet_customer_details.php?id=${accountId}`
      );

      if (data.status === 200) {

        setSelectedDvplAccount(accountId);

        setDvplInfo(data);

      } else {

        toast.error("Unable to load DVPL details");

      }

    } catch (err) {

      toast.error("Failed to load DVPL account");

    } finally {

      setDvplLoading(false);

    }
  };

  const syncPlans = async () => {
    if (!customer?.id) return;

    setExpiryLoading(true);
    setPioneerAddUserError(null);

    const res = await apiClient.get(
      `/customer/sync_user_plans.php?user_id=${customer.id}`,
      { responseType: "text", validateStatus: () => true }
    );

    const text = res.data;

    try {
      const data = JSON.parse(text);

      if (data.success) {
        // Pioneer's own STB record carries the exact expiration datetime
        // (plans can lapse mid-day, not just at midnight) — prefer that
        // over the date-only pioneeriptv_expiry field when it's available.
        // A customer can have MULTIPLE STBs, so we keep the full list and
        // just use the first one for the summary expiry shown on the card.
        const pioneerStbList = data?.pioneeriptv?.data?.stb || [];
        const pioneerStb = pioneerStbList[0];
        const pioneerExpiry =
          pioneerStb?.expiration ||
          data?.pioneeriptv?.data?.user?.expiration ||
          data.data.pioneeriptv_expiry;

        // Internet/OneRADIUS lookup, same shape as pioneeriptv:
        // { status, results: { expiry_date, package, sub_plan, ... } }.
        // Falls back to a plain internet_expiry column if the backend
        // hasn't started sending the full lookup payload yet.
        const internetExpiry =
          data?.internet?.results?.expiry_date || data.data.internet_expiry;

        // Same idea for DVPL. NOTE: this depends on sync_user_plans.php
        // returning a `dvpl` key (array of accounts) alongside `internet`
        // — until that's added on the backend, this just quietly stays
        // empty/null and the DVPL tab shows "not linked" for everyone,
        // the same safe fallback as any other not-yet-enabled provider.
        const dvplExpiry =
          data?.dvpl?.results?.expiry_date || data.data.dvpl_expiry;

        setExpiryData({
          vrplay: data.data.vrplay_expiry,
          ottplay1: data.data.ottplay_expiry1,
          ottplay2: data.data.ottplay_expiry2,
          watcho: data.data.watcho_expiry,
          playboxtv: data.data.playboxtv_expiry,
          pioneeriptv: pioneerExpiry,
          etvwin: data.data.etvwin_expiry,
          internet: internetExpiry,
          dvpl: dvplExpiry
        });

        setPioneerStbs(pioneerStbList);

        // Full per-provider lookup payload (status/desc), used to detect
        // customers who aren't registered with Pioneer IPTV yet.
        setPioneerIptvInfo(data.pioneeriptv || null);

        // Same idea for Internet — lets the card tell "not linked" apart
        // from "linked, here's the plan".
        const accounts = Array.isArray(data.internet)
          ? data.internet
          : [];

        setInternetAccounts(accounts);

        if (accounts.length > 0) {

          const selectedAccount =
            accounts.find(
              x => Number(x.internet_customer_id) === Number(internetId)
            ) ||
            accounts.find(
              x => Number(x.is_default) === 1
            ) ||
            accounts[0];

          // Which account's data to load is decided every time (fine —
          // idempotent, just picks the right one to display). Whether to
          // FORCE the tab to "internet" is handled entirely by a separate
          // effect below (the one also handling the plain first-load
          // default) — pulling it out of this repeatedly-called function
          // entirely, rather than trying to guard it in-place here, since
          // that guard turned out not to hold up in practice.
          loadInternetCustomer(selectedAccount.id);

        }

        // DVPL accounts — same array shape as `data.internet`, expected
        // under `data.dvpl` once the backend sends it (see the dvplExpiry
        // comment above). `Array.isArray` keeps this a no-op until then.
        const dvplAccountsList = Array.isArray(data.dvpl)
          ? data.dvpl
          : [];

        setDvplAccounts(dvplAccountsList);

        if (dvplAccountsList.length > 0) {

          const selectedDvplAcc =
            dvplAccountsList.find(
              x => Number(x.internet_customer_id) === Number(dvplId)
            ) ||
            dvplAccountsList.find(
              x => Number(x.is_default) === 1
            ) ||
            dvplAccountsList[0];

          loadDvplCustomer(selectedDvplAcc.id);

        }
      } else {
        toast.error("Failed to sync plans");
      }

    } catch (e) {
      console.error("INVALID JSON:", text);
      toast.error("Server returned invalid response");
    } finally {
      setExpiryLoading(false);
    }
  };

  useEffect(() => {
    if (customer?.id) {
      syncPlans();
    }
  }, [customer]);

  useEffect(() => {
    if (customer?.id) {
      syncPlans();
    }
  }, [customer?.id]);

  const isActivePlan = (expiry) => {
    if (!expiry) return false;

    const today = new Date();
    const exp = new Date(expiry);

    today.setHours(0, 0, 0, 0);
    exp.setHours(0, 0, 0, 0);

    return exp >= today;
  };

  useEffect(() => {

    // Guarded so this only ever picks a tab ONCE per page load — see
    // the defaultTabPicked comment above selectProviderTab. Without
    // this guard, every data refetch re-ran this and silently snapped
    // the view back to the default, discarding the user's actual
    // manual tab selection.
    if (defaultTabPicked) return;

    // Wait for get_customer_visible_packages.php to actually come back
    // before deciding anything. Without this, this effect ran on the
    // very first render too, while visiblePackages was still its
    // initial {} — every real provider key was therefore falsy, but
    // the "transactions" entry in priorityOrder always evaluates to
    // visible (it's a utility tab, not gated on any package), so it
    // "won" the race and got locked in as the default via
    // defaultTabPicked before the real data ever arrived. That's why
    // Transactions was showing by default instead of the customer's
    // actual first enabled provider.
    if (!visiblePackagesLoaded) return;

    // If the URL already names a tab (survives a page reload — see
    // selectProviderTab), use that directly instead of computing a
    // fresh default, but only once that tab is actually available in
    // visiblePackages (it may still be loading on the very first
    // render, in which case this effect just runs again next time
    // visiblePackages changes, still guarded by defaultTabPicked above).
    const urlTab = searchParams.get("tab");
    if (urlTab && visiblePackages[urlTab]) {
      setActiveProvider(urlTab);
      setDefaultTabPicked(true);
      return;
    }

    // Otherwise, default to whichever provider is actually visible for
    // this customer, in the same priority order the tab list itself
    // uses (providerTabs, further down) — instead of the old hardcoded
    // "internet if enabled, otherwise always watcho" fallback, which
    // showed a blank/wrong tab for any customer who had neither of
    // those two specifically enabled (e.g. Pioneer IPTV only).
    // Keep this list in sync with providerTabs if a new provider is
    // ever added. "transactions" sits last — a utility tab, not
    // something that should out-rank an actual active provider as the
    // default, but still there as a fallback for a customer with no
    // provider enabled at all.
    const priorityOrder = [
      "internet", "dvpl", "watcho", "etvwin", "playboxtv",
      "pioneeriptv", "railtel", "vrplay", "transactions"
    ];

    const firstVisibleKey = priorityOrder.find((key) => {
      if (key === "playboxtv") {
        return visiblePackages.playboxtv && isActivePlan(expiryData?.playboxtv);
      }
      if (key === "transactions") {
        return true; // always visible, same as its providerTabs entry
      }
      return visiblePackages[key];
    });

    if (firstVisibleKey) {
      setActiveProvider(firstVisibleKey);
      setDefaultTabPicked(true);
    }

  }, [visiblePackages, visiblePackagesLoaded, expiryData, defaultTabPicked, searchParams]);

  // Handles the ?internet=X deep link's forced tab-switch — pulled out
  // of syncPlans() entirely (where it used to live, guarded by a ref)
  // into its own effect with the exact same unconditional, checked-first
  // guard as the auto-pick effect above. That structural guarantee is
  // what actually closes the bug this time: defaultTabPicked is checked
  // BEFORE anything else, with no `|| internetId`-style path that can
  // bypass it, so once any tab has been picked once — manually or via
  // this deep link — nothing in here can force a switch back, no matter
  // how many more times a recharge or change-package action on some
  // other tab causes internetAccounts to refresh.
  useEffect(() => {
    if (defaultTabPicked) return;
    if (!internetId) return;
    if (internetAccounts.length === 0) return;

    const isDeepLinkedAccountPresent = internetAccounts.some(
      x => Number(x.internet_customer_id) === Number(internetId)
    );

    if (isDeepLinkedAccountPresent) {
      selectProviderTab("internet");
    }
  }, [internetId, internetAccounts, defaultTabPicked]);

  // Exact same pattern for the DVPL deep link (?dvpl=X) — its own
  // effect, its own guard, no bypass path, for the same reason the
  // comment above explains for Internet.
  useEffect(() => {
    if (defaultTabPicked) return;
    if (!dvplId) return;
    if (dvplAccounts.length === 0) return;

    const isDvplDeepLinkedAccountPresent = dvplAccounts.some(
      x => Number(x.internet_customer_id) === Number(dvplId)
    );

    if (isDvplDeepLinkedAccountPresent) {
      selectProviderTab("dvpl");
    }
  }, [dvplId, dvplAccounts, defaultTabPicked]);

  const fetchVisiblePackages = async () => {
    try {
      const { data } = await apiClient.get(
        `/customer/get_customer_visible_packages.php?user_id=${customer.id}`
      );

      if (data.success) {
        setVisiblePackages(data.packages);
      }
    } catch (err) {
      console.error(err);
    } finally {
      // Marks the point where visiblePackages actually reflects this
      // customer's real data (success OR failure) instead of its
      // initial {} — see the visiblePackagesLoaded guard in the
      // default-tab effect below for why this matters.
      setVisiblePackagesLoaded(true);
    }
  };

  // --- RailTel ---
  // Runs once, the first time the RailTel tab is opened. No more
  // mobile-number search (the provider's API doesn't support it) — this
  // now reads whichever usernames we've already linked for this customer
  // (max 2), then does a live lookup for each one to get current
  // package/expiry/balance/status.
  const loadLinkedRailtelAccounts = async () => {
    if (!railtelEnabled || !customer?.id) return;

    setRailtelLoading(true);
    try {
      const { data } = await railtelGetLinkedAccounts(customer.id);

      if (!data.success) {
        toast.error(data.message || "Unable to load linked RailTel accounts");
        return;
      }

      const links = data.accounts || [];
      setRailtelLinkedAccounts(links);
      setRailtelLookedUp(true);

      if (links.length === 0) {
        setRailtelSubscribers([]);
        setSelectedRailtelSubscriber(null);
        return;
      }

      // At most 2, so doing these one at a time (not Promise.all) keeps
      // this simple and the error handling per-account rather than
      // failing the whole tab if one lookup has a problem.
      const resolved = [];
      for (const link of links) {
        try {
          const { data: lookupData } = await railtelLookupByUsername(link.railtel_username);
          if (lookupData.success) {
            resolved.push({ ...lookupData.subscriber, linkedAccountId: link.id });
          }
        } catch (err) {
          toast.error(`Failed to load ${link.railtel_username} from RailTel`);
        }
      }

      setRailtelSubscribers(resolved);
      if (resolved.length > 0) {
        selectRailtelSubscriber(resolved[0]);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to load RailTel accounts");
    } finally {
      setRailtelLoading(false);
    }
  };

  // Switches which of the customer's RailTel accounts is shown, and
  // pulls that account's live online status.
  const selectRailtelSubscriber = (subscriber) => {
    setSelectedRailtelSubscriber(subscriber);
    loadRailtelOnlineStatus(subscriber.username);
  };

  const loadRailtelOnlineStatus = async (username) => {
    setRailtelOnlineLoading(true);
    try {
      const { data } = await railtelGetOnlineStatus(username);
      setRailtelOnline(!!data?.is_online);
    } catch (err) {
      setRailtelOnline(false);
    } finally {
      setRailtelOnlineLoading(false);
    }
  };

  // Re-runs the live lookup for whichever account is currently selected
  // (fresh package/expiry/balance/status) and its online status, and
  // updates that one entry in railtelSubscribers so the chip stays in
  // sync too.
  const refreshRailtelSubscriber = async () => {
    if (!selectedRailtelSubscriber) return;

    setRailtelRefreshLoading(true);
    try {
      const { data } = await railtelLookupByUsername(selectedRailtelSubscriber.username);
      if (data.success) {
        const updated = { ...data.subscriber, linkedAccountId: selectedRailtelSubscriber.linkedAccountId };
        setSelectedRailtelSubscriber(updated);
        setRailtelSubscribers((prev) =>
          prev.map((s) => (s.username === updated.username ? updated : s))
        );
      }
    } catch (err) {
      toast.error("Failed to refresh from RailTel");
    } finally {
      setRailtelRefreshLoading(false);
    }
    loadRailtelOnlineStatus(selectedRailtelSubscriber.username);
  };

  const handleAddRailtelAccount = async () => {
    const trimmed = newRailtelUsername.trim();
    if (!trimmed) {
      toast.warn("Enter the RailTel username first.");
      return;
    }
    setAddingRailtelAccount(true);
    try {
      const { data } = await railtelLinkAccount(customer.id, trimmed);
      if (data.success) {
        toast.success(
          data.provider_name
            ? `Linked — RailWire shows this account as "${data.provider_name}" (${data.provider_mobile || "no mobile on file"}). Double-check that matches this customer.`
            : "RailTel account linked"
        );
        setNewRailtelUsername("");
        setShowAddRailtelAccount(false);
        loadLinkedRailtelAccounts();
      } else {
        toast.error(data.message || "Failed to link RailTel account");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to link RailTel account");
    } finally {
      setAddingRailtelAccount(false);
    }
  };

  const handleRemoveRailtelAccount = async (accountId) => {
    if (!window.confirm("Remove this RailTel account from this customer?")) return;
    try {
      const { data } = await railtelUnlinkAccount(accountId);
      if (data.success) {
        toast.success("RailTel account removed");
        loadLinkedRailtelAccounts();
      } else {
        toast.error(data.message || "Failed to remove RailTel account");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to remove RailTel account");
    }
  };

  useEffect(() => {
    if (activeProvider === "railtel" && !railtelLookedUp) {
      loadLinkedRailtelAccounts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeProvider]);

  useEffect(() => {
    if (customer?.id && token) {
      fetchVisiblePackages();
    }
  }, [customer?.id, token]);

  const isExpired = (date) => {
    if (!date) return false;
    return new Date(date) < new Date();
  };

  const openEditCustomerForm = (cust) => {
    setEditForm({
      id: cust.id,
      username: cust.username,
      password: cust.password,
      name: cust.name,
      lastName: cust.lastName,
      MobileNumber: cust.MobileNumber,
      EmailId: cust.EmailId,
      address: cust.address,
      ExpiryDate: cust.ExpiryDate,
      maximumDevices: cust.maximumDevices,
      operatorDetails: cust.operatorDetails,
      operatorId: cust.operatorId,
      autoplay: cust.autoplay,
      remarks: cust.remarks
    });
    setShowEditForm(true);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;

    if (name === "operatorId") {
      const selectedOperator = operators.find(o => String(o.id) === String(value));

      setEditForm(prev => ({
        ...prev,
        operatorId: value,
        operatorDetails: selectedOperator
          ? `${selectedOperator.operatorName} - ${selectedOperator.phoneNumber}`
          : ""
      }));
    } else {
      setEditForm(prev => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = () => {
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!editForm.name.trim()) {
      toast.error("Name is required");
      return false;
    } else if (!nameRegex.test(editForm.name.trim())) {
      toast.error("Name can only contain letters and spaces");
      return false;
    }

    if (!editForm.lastName.trim()) {
      toast.error("Last Name is required");
      return false;
    } else if (!nameRegex.test(editForm.lastName.trim())) {
      toast.error("Last Name can only contain letters and spaces");
      return false;
    }

    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(editForm.MobileNumber)) {
      toast.error("Please enter a valid 10-digit phone number.");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (editForm.EmailId && !emailRegex.test(editForm.EmailId)) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    return true;
  };

  const submitEditForm = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      await apiClient.put('/allCustomers.php', editForm);
      toast.success('Customer updated successfully!');
      setShowEditForm(false);
      fetchCustomer(true)
    } catch (err) {
      toast.error('Failed to update Customer');
    } finally {
      setLoading(false);
    }
  };

  const isActive = (date) => new Date(date) >= new Date();

  const handleRenew = (type) => {
    setConfirmModal({ open: true, type });
  };

  const fetchPioneerBranches = async () => {
    setPioneerBranchesLoading(true);
    setSelectedBranch(null);
    try {
      const { data } = await apiClient.get(
        `/customer/get_pioneeriptv_branches.php?operator_id=${customer.operatorId}`
      );
      const branches = data?.branches || [];
      setPioneerBranches(branches);
      // Silent auto-select when there's only one — no need to ask.
      if (branches.length === 1) {
        setSelectedBranch(branches[0]);
      }
    } catch (err) {
      toast.error("Failed to load Pioneer IPTV branches");
      setPioneerBranches([]);
    } finally {
      setPioneerBranchesLoading(false);
    }
  };

  const openPioneerRechargePicker = (stb, isAdvance) => {

    setSelectedStb(stb);

    setAdvanceRecharge(isAdvance);

    setSelectedPlan(
      pioneerPlanOptions.length
        ? pioneerPlanOptions[0]
        : null
    );

    fetchPioneerBranches();

    setShowRechargeDialog(true);

  }

  const confirmPioneerRecharge = async () => {

    if (!selectedPlan)
      return;

    if (!selectedStb)
      return;

    if (!selectedBranch) {
      toast.warn("Please select a branch to recharge.");
      return;
    }

    // Prevent double click
    if (actionLoading === "pioneeriptv") return;

    try {

      setActionLoading("pioneeriptv");
      // console.log("Recharging Pioneer IPTV:", {
      //   customer_id: customer.id,
      //   device_id: selectedStb.stb_box,
      //   plan_id: selectedPlan.id,
      //   branch_id: selectedBranch.id,
      //   advance: advanceRecharge
      // });

      const response = await rechargePioneerPlan({

        customer_id: customer.id,

        device_id: selectedStb.stb_box,

        plan_id: selectedPlan.id,

        branch_id: selectedBranch.id,

        advance: advanceRecharge,

        // Only meaningful for advance recharge — lets the backend start
        // the new period right after the box's current expiry instead of
        // from today.
        current_expiry: selectedStb.expiration

      });

      // rechargePioneerPlan already shows its own toast.success on success —
      // no need to toast again here.

      setShowRechargeDialog(false);

      fetchCustomer(true);

    }

    catch (error) {

      // rechargePioneerPlan already shows a toast with the real backend
      // error message (or a network-error fallback) before re-throwing.
      // Toasting again here would only stack a generic, less useful
      // "Recharge failed" message on top of the specific one — so this
      // catch exists purely to stop the error here and let `finally`
      // reset the loading state, not to show anything itself.
      console.error("Pioneer recharge failed:", error);

    }

    finally {

      setActionLoading("");

    }

  }

  const confirmRecharge = async () => {
    const type = confirmModal.type;
    setConfirmModal({ open: false, type: null });

    setActionLoading(type);

    try {
      if (type === "vrplay") {
        await rechargeVrplay(customer.vrplay_planId);
      }

      if (type === "watcho") {
        await rechargeWatchoPlan(customer.watcho_planId);
      }

      if (type === "playboxtv") {
        await rechargePlayboxtvPlan(customer.playboxtv_planId);
      }

      if (type === "antiptv") {
        await rechargeAntiptvPlan(customer.antiptv_planId);
      }

      if (type === "pioneeriptv") {
        await rechargePioneerIptvPlan(customer.pioneeriptv_planId);
      }

      if (type === "etvwin") {
        await rechargeEtvwinPlan(customer.etvwin_planId);
      }

    } finally {
      setActionLoading(null);
    }
  };

  const handleLinkInternetAccount = () => {
    navigate(`/link-internet-account/${customer.id}`)
  };

  // Same page, `?type=dvpl` tells LinkInternetAccountPage which
  // provider's form to render — no separate route needed.
  const handleLinkDvplAccount = () => {
    navigate(`/link-internet-account/${customer.id}?type=dvpl`)
  };

  const rechargeVrplay = async (planId) => {
    // if (!window.confirm("Are you sure you want to recharge VRPLAY plan?")) return;

    try {
      const { data } = await apiClient.post(
        "/customer/recharge_vrplay.php",
        {
          user_id: customer.id,
          plan_id: planId
        }
      );

      if (data.success) {
        toast.success("VRPLAY recharged");
        triggerCooldown("vrplay");
        syncPlans(); // refresh expiry
      } else {
        toast.error(data.error || "Failed");
      }

    } catch {
      toast.error("Server error");
    }
  };

  const rechargeWatchoPlan = async (planId) => {
    // if (!window.confirm("Are you sure you want to recharge Watcho plan?")) return;
    try {
      const res = await apiClient.post(
        "/customer/recharge_watcho.php",
        {
          user_id: customer.id,
          plan_id: planId
        },
        { responseType: "text", validateStatus: () => true }
      );

      // 🔥 IMPORTANT: read only once
      const text = res.data;
      // console.log(text);

      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error("INVALID JSON:", text);
        toast.error("Server returned invalid response");
        return;
      }

      // console.log("WATCHO RESPONSE:", data);

      // ❌ API FAILED
      if (res.status < 200 || res.status >= 300 || !data.success) {
        // console.error("Watcho recharge failed:", data);

        toast.error(data.error || "Recharge failed");

        // optional debug
        if (data.watcho_response) {
          // console.log("WATCHO DEBUG:", data.watcho_response);
        }

        return;
      }

      // ✅ SUCCESS
      toast.success("Watcho plan recharged successfully");
      triggerCooldown("watcho");

      // 🔄 Update wallet UI
      if (data.wallet !== undefined) {
        setOperator(prev => ({
          ...prev,
          wallet: data.wallet
        }));
      }

      // 🔄 Refresh expiry
      // 🔄 Refresh customer data
      fetchCustomer(true);

    } catch (err) {
      console.error("Watcho API error:", err);
      toast.error("Server error during recharge");
    }
  };

  const rechargePlayboxtvPlan = async (planId) => {
    // if (!window.confirm("Are you sure you want to recharge PlayBox TV plan?")) return;

    try {
      const res = await apiClient.post(
        "/customer/recharge_playboxtv.php",
        {
          user_id: customer.id,
          plan_id: planId
        },
        { responseType: "text", validateStatus: () => true }
      );

      // 🔥 IMPORTANT: read response safely
      const text = res.data;
      // console.log("PLAYBOX RAW:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error("INVALID JSON:", text);
        toast.error("Server returned invalid response");
        return;
      }

      // console.log("PLAYBOX RESPONSE:", data);

      // ❌ API FAILED
      if (res.status < 200 || res.status >= 300 || !data.success) {
        console.error("PlayBox recharge failed:", data);

        toast.error(data.error || "Recharge failed");

        if (data.playboxtv_response) {
          // console.log("PLAYBOX DEBUG:", data.playboxtv_response);
        }

        return;
      }

      // ✅ SUCCESS
      toast.success("PlayBox TV plan recharged successfully");
      triggerCooldown("playboxtv");

      // 🔄 Update wallet UI (same as Watcho)
      if (data.wallet !== undefined) {
        setOperator(prev => ({
          ...prev,
          wallet: data.wallet
        }));
      }

      // 🔄 Refresh expiry
      // 🔄 Refresh customer data
      fetchCustomer(true);

    } catch (err) {
      console.error("PlayBox API error:", err);
      toast.error("Server error during recharge");
    }
  };

  const rechargePioneerPlan = async ({
    customer_id,
    device_id,
    plan_id,
    branch_id,
    advance,
    current_expiry
  }) => {
    try {
      const res = await apiClient.post(
        "/customer/recharge_pioneeriptv.php",
        {
          user_id: customer_id,
          plan_id,
          device_id,
          branch_id,
          advance,
          current_expiry
        }
      );

      const data = res.data;
      // console.log("Pioneer recharge response:", data);

      if (!data.success) {
        // Backend sends the failure reason under "error", not "message".
        throw new Error(data.error || "Recharge failed");
      }

      if (data.wallet !== undefined) {
        setOperator(prev => ({
          ...prev,
          wallet: data.wallet
        }));
      }

      const providerMsg =
        data?.pioneeriptv_response?.message ||
        data?.pioneeriptv_response?.data?.desc ||
        "Recharge successful";

      const cleanMsg = providerMsg.replace(/\s+/g, " ").trim();

      const message = cleanMsg.includes("Pre Renewed")
        ? "Advance Renewal successful ✅"
        : cleanMsg.includes("Renewed")
          ? "Recharge successful ✅"
          : cleanMsg.includes("Created")
            ? "Plan Activated successfully ✅"
            : cleanMsg;

      toast.success(message);

      return {
        ...data,
        message
      };

    } catch (err) {
      // The backend's error body looks like {"success":false,"error":"..."} —
      // key is "error", NOT "message". Axios rejects on any non-2xx status
      // (e.g. the 400 the backend sends for "Insufficient wallet balance"),
      // so this is the path that actually runs for most backend failures;
      // check both keys so real backend text is shown instead of Axios's
      // generic "Request failed with status code 400".
      const message =
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.message ||
        "Server error during recharge";

      toast.error(message);

      throw err;
    }
  };

  const rechargeAntiptvPlan = async (planId) => {
    // if (!window.confirm("Are you sure you want to recharge ANT IPTV plan?")) return;

    try {
      const res = await apiClient.post(
        "/customer/recharge_antiptv.php",
        {
          user_id: customer.id,
          plan_id: planId
        },
        { responseType: "text", validateStatus: () => true }
      );

      const text = res.data;

      let data;
      try {
        data = JSON.parse(text);

      } catch {
        console.error("INVALID JSON:", text);
        toast.error("Server returned invalid response");
        return;
      }

      // ❌ API FAILED
      if (res.status < 200 || res.status >= 300 || !data.success) {
        toast.error(data.error || "Recharge failed");
        return;
      }

      // ✅ GET PROVIDER MESSAGE
      const providerMsg =
        data?.antiptv_response?.message || "Recharge successful";

      // normalize message (remove line breaks/spaces)
      const cleanMsg = providerMsg.replace(/\s+/g, " ").trim();

      // 🎯 SMART TOAST
      if (cleanMsg.includes("Pre Renewed")) {
        toast.success("Advance Renewal successful ✅");
      } else if (cleanMsg.includes("Renewed")) {
        toast.success("Recharge successful ✅");
      } else if (cleanMsg.includes("Created")) {
        toast.success("Plan Activated successfully ✅");
      } else {
        toast.success(cleanMsg);
      }

      // 💰 UPDATE WALLET (if returned)
      if (data.wallet !== undefined) {
        setOperator(prev => ({
          ...prev,
          wallet: data.wallet
        }));
      }

      // 🔄 REFRESH DATA
      fetchCustomer(true);

    } catch (err) {
      console.error("ANT IPTV error:", err);
      toast.error("Server error during recharge");
    }
  };

  const rechargePioneerIptvPlan = async (planId) => {
    // if (!window.confirm("Are you sure you want to recharge Pioneer IPTV plan?")) return;

    try {
      const res = await apiClient.post(
        "/customer/recharge_pioneeriptv.php",
        {
          user_id: customer.id,
          plan_id: planId
        },
        { responseType: "text", validateStatus: () => true }
      );

      const text = res.data;

      let data;

      try {
        data = JSON.parse(text);

      } catch {
        console.error("INVALID JSON:", text);
        toast.error("Server returned invalid response");
        return;
      }

      // ❌ API FAILED
      if (res.status < 200 || res.status >= 300 || !data.success) {
        toast.error(data.error || "Recharge failed");
        return;
      }

      // ✅ GET PROVIDER MESSAGE
      const providerMsg =
        data?.pioneeriptv_response?.message || "Recharge successful";

      // normalize message (remove line breaks/spaces)
      const cleanMsg = providerMsg.replace(/\s+/g, " ").trim();

      // 🎯 SMART TOAST
      if (cleanMsg.includes("Pre Renewed")) {
        toast.success("Advance Renewal successful ✅");
      } else if (cleanMsg.includes("Renewed")) {
        toast.success("Recharge successful ✅");
      } else if (cleanMsg.includes("Created")) {
        toast.success("Plan Activated successfully ✅");
      } else {
        toast.success(cleanMsg);
      }

      // 💰 UPDATE WALLET (if returned)
      if (data.wallet !== undefined) {
        setOperator(prev => ({
          ...prev,
          wallet: data.wallet
        }));
      }

      // 🔄 REFRESH DATA
      fetchCustomer(true);

    } catch (err) {
      console.error("Pioneer IPTV error:", err);
      toast.error("Server error during recharge");
    }
  };

  const rechargeEtvwinPlan = async (planId) => {
    // if (!window.confirm("Are you sure you want to recharge ETV Win plan?")) return;
    try {
      const res = await apiClient.post(
        "/customer/recharge_etvwin.php",
        {
          user_id: customer.id,
          plan_id: planId
        },
        { responseType: "text", validateStatus: () => true }
      );
      const text = res.data;
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        console.error("INVALID JSON:", text);
        toast.error("Server returned invalid response");
        return;
      }

      if (data.success) {
        toast.success("ETV Win plan recharged successfully");
        triggerCooldown("etvwin");
        fetchCustomer(true);
      } else {
        toast.error(data.error || "Recharge failed");
      }
    } catch (err) {
      console.error("ETV Win API error:", err);
      toast.error("Server error during recharge");
    }
  };

  const pioneerNeedsUser =
    !!pioneerIptvInfo && Number(pioneerIptvInfo.status) !== 200;

  const openAddPioneerUserDialog = () => {
    if (!customer?.id) return;
    fetchPioneerBranches();
    setShowAddPioneerUserDialog(true);
  };

  const handleAddPioneerUser = async () => {
    if (!customer?.id) return;

    if (!selectedBranch) {
      toast.warn("Please select a branch first.");
      return;
    }

    setAddUserLoading(true);
    setPioneerAddUserError(null);

    try {
      const res = await apiClient.post(
        "/customer/add_pioneeriptv_user.php",
        { user_id: customer.id, branch_id: selectedBranch.id },
        { responseType: "text", validateStatus: () => true }
      );

      const text = res.data;

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        console.error("INVALID JSON:", text);
        toast.error("Server returned invalid response");
        return;
      }

      if (res.status < 200 || res.status >= 300 || !data.success) {
        const rawError = data.error || "Failed to create Pioneer IPTV user";

        // Pioneer's own "Mobile Number Already Exists" wording is confusing
        // here, since it actually means the number is tied to a different
        // account on their side, not that this add attempt duplicated itself.
        const friendlyError = /mobile number already exists/i.test(rawError)
          ? "Mobile Number is Registered some where else."
          : rawError;

        setPioneerAddUserError(friendlyError);
        toast.error(friendlyError);
        return;
      }

      toast.success("Pioneer IPTV user created successfully");
      setShowAddPioneerUserDialog(false);

      // 🔄 REFRESH DATA
      fetchCustomer(true);

    } catch (err) {
      console.error("Add Pioneer IPTV user error:", err);
      toast.error("Server error while creating user");
    } finally {
      setAddUserLoading(false);
    }
  };

  // Unmap a Pioneer STB (e.g. customer swapped boxes). Uses the new
  // remove_pioneeriptv_stb.php endpoint.
  const handleRemovePioneerStb = async (deviceId) => {
    if (!customer?.id || !deviceId) return;
    if (!window.confirm(`Remove STB ${deviceId} from this customer's Pioneer IPTV account?`)) return;

    setPioneerRemoveStbLoading(true);

    try {
      const res = await apiClient.post(
        "/customer/remove_pioneeriptv_stb.php",
        { user_id: customer.id, device_id: deviceId },
        { responseType: "text", validateStatus: () => true }
      );

      const text = res.data;
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        console.error("INVALID JSON:", text);
        toast.error("Server returned invalid response");
        return;
      }

      if (res.status < 200 || res.status >= 300 || !data.success) {
        toast.error(data.error || "Failed to remove STB");
        return;
      }

      toast.success("STB removed successfully");
      syncPlans();

    } catch (err) {
      console.error("Remove Pioneer STB error:", err);
      toast.error("Server error while removing STB");
    } finally {
      setPioneerRemoveStbLoading(false);
    }
  };

  const [planModal, setPlanModal] = useState({
    visible: false,
    type: null,
    slot: "1"   // ✅ default
  });

  const handleChange = async (type, slot = "1") => {

    // 🔥 FETCH BASED ON CURRENT USER STATE

    if (type === "playboxtv" && slot === "1" && plansData.playboxtv) {
      await fetchComboOptions({ playboxtv: plansData.playboxtv.id });
    }

    if (type === "antiptv" && slot === "1" && plansData.antiptv) {
      await fetchComboOptions({ antiptv: plansData.antiptv.id });
    }

    if (type === "etvwin" && slot === "1" && plansData.etvwin) {
      await fetchComboOptions({ etvwin: plansData.etvwin.id });
    }

    if (type === "pioneeriptv" && slot === "1" && plansData.pioneeriptv) {
      await fetchComboOptions({ pioneeriptv: plansData.pioneeriptv.id });
    }

    if (type === "antiptv" && slot === "1" && plansData.antiptv) {
      await fetchComboOptions({ antiptv: plansData.antiptv.id });
    }

    if (type === "etvwin" && slot === "1" && plansData.etvwin) {
      await fetchComboOptions({ etvwin: plansData.etvwin.id });
    }

    if (type === "pioneeriptv" && slot === "1" && plansData.pioneeriptv) {
      await fetchComboOptions({ pioneeriptv: plansData.pioneeriptv.id });
    }

    setActionLoading(type + slot);

    setPlanModal({
      visible: true,
      type,
      slot
    });

    setTimeout(() => setActionLoading(null), 300);
  };

  const getDevices = async () => {
    setDeviceType("normal");
    setSelectedUserForDevices(customer); // ✅ ADD THIS
    setDevicesModalVisible(true);

    try {
      const { data } = await apiClient.get(
        `/get_user_devices.php?user_id=${customer.id}`
      );

      setDevices(data.devices || []);
    } catch {
      toast.error("Failed to load devices");
    }
  };

  const removeDevice = async (userId, deviceId) => {
    if (!window.confirm('Are you sure you want to remove this device?')) return;
    try {
      const { data } = await apiClient.post("/remove_customer_device.php", {
        user_id: userId,
        device_id: deviceId,
      });

      if (data.success) {
        toast.success('Device removed successfully!');
        fetchCustomer(true);
        getDevices(customer.id);
      } else {
        toast.error('Failed to remove device: ' + data.message);
      }
    } catch (error) {
      toast.warn('An error occurred while removing the device.');
    }
  };

  const getStelfiberDevices = async () => {
    setDeviceType("stelfiber");
    setSelectedUserForDevices(customer);
    setDevicesModalVisible(true);
    try {
      const { data } = await apiClient.get(
        `/get_user_stelfiber_devices.php?user_id=${customer.id}`
      );

      if (data.success && Array.isArray(data.devices)) {
        setStelfiberDevices(data.devices);
      } else {
        setStelfiberDevices([]);
      }
    } catch (error) {
      setStelfiberDevices([]);
    }
  };

  const removeStelfiberDevice = async (userId, deviceId) => {
    if (!window.confirm('Are you sure you want to remove this device?')) return;
    try {
      const { data } = await apiClient.post("/remove_customer_stelfiber_device.php", {
        user_id: userId,
        device_id: deviceId,
      });

      if (data.success) {
        toast.success('Device removed successfully!');
        getStelfiberDevices();
      } else {
        toast.error('Failed to remove device: ' + data.message);
      }
    } catch (error) {
      toast.warn('An error occurred while removing the device.');
    }
  };

  const fetchAssignableStelfiber = async () => {
    if (customer.loginDevices >= customer.maximumDevices) {
      toast.error("Device limit reached");
      return;
    }

    setAssignLoading(true);

    try {
      const { data } = await apiClient.get(
        `/get_operator_stelfiber_devices.php?user_id=${customer.id}`
      );

      if (data.success) {
        setAssignDevices(data.devices);
        setShowAssign(true);
      } else {
        toast.error(data.message);
      }
    } catch {
      toast.error("Network error");
    } finally {
      setAssignLoading(false);
    }
  };

  const assignStelfiberDevice = async (deviceId) => {
    if (!window.confirm("Assign this device?")) return;
    setAssignLoading(true);
    try {
      // validateStatus keeps this from throwing on a non-2xx response —
      // there's no catch block here, only finally, so we handle failure
      // via data.success below exactly like the old fetch()-based code did.
      const { data } = await apiClient.post(
        "/assign_stelfiber_device.php",
        {
          device_id: deviceId,
          user_id: customer.id
        },
        { validateStatus: () => true }
      );

      if (data.success) {
        toast.success("Device Assigned");
        setAssignSearch("");
        setShowAssign(false);
        setDevicesModalVisible(false);
        getStelfiberDevices();
      } else {
        toast.error(data.message);
      }
    } finally {
      setAssignLoading(false);
    }
  };

  const handleResetDevicesCount = async (userId) => {
    if (!window.confirm("Are you sure you want to reset all devices for this user?")) return;

    try {
      const { data } = await apiClient.post("/reset_customer_devicecount.php", {
        user_id: userId,
      });

      if (data.success) {
        toast.success("Device count reset successfully!");
        fetchCustomer(true);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.warn("An error occurred while resetting the device count.");
    }
  };

  const triggerCooldown = (type, minutes = 5) => {
    const expiryTime = Date.now() + minutes * 60 * 1000;

    const updated = {
      ...renewCooldown,
      [type]: expiryTime
    };

    setRenewCooldown(updated);
    localStorage.setItem(`renewCooldown_${id}`, JSON.stringify(updated));
  };

  useEffect(() => {
    const stored = localStorage.getItem(`renewCooldown_${id}`);
    if (stored) {
      setRenewCooldown(JSON.parse(stored));
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setRenewCooldown(prev => ({ ...prev }));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const isCooldownActive = (type) => {
    const expiry = Number(renewCooldown[type]);
    return expiry && Date.now() < expiry;
  };

  const getRemainingTime = (type) => {
    const expiry = Number(renewCooldown[type]);
    if (!expiry) return null;

    const diff = expiry - Date.now();
    if (diff <= 0) return null;

    const min = Math.floor(diff / 60000);
    const sec = Math.floor((diff % 60000) / 1000);

    return `${min}m ${sec}s`;
  };


  const fetchComboOptions = async (filters) => {
    try {
      const params = new URLSearchParams(filters).toString();

      const { data } = await apiClient.get(
        `/customer/get_operator_plans.php?${params}`
      );

      if (data.success) {
        setAllowedPlans({
          watcho: data.data.watcho,
          playboxtv: data.data.playboxtv,
          antiptv: data.data.antiptv,
          pioneeriptv: data.data.pioneeriptv,
          etvwin: data.data.etvwin
        });
      }
    } catch (err) {
      console.error("Combo fetch error", err);
    }
  };

  const showComboButton =
    !isActivePlan(expiryData?.playboxtv) &&
    !isActivePlan(expiryData?.watcho);

  const providerTabs = [
    {
      key: "internet",
      title: "🌐 Internet",
      visible: visiblePackages.internet
    },
    {
      key: "dvpl",
      title: "📶 DVPL",
      // Same gating pattern as every other provider — true only once
      // get_customer_visible_packages.php reports a `dvpl` key (backend
      // work tracked separately; until then this tab just stays hidden).
      visible: visiblePackages.dvpl
    },
    {
      key: "watcho",
      title: "📺 Watcho",
      visible: visiblePackages.watcho
    },
    {
      key: "etvwin",
      title: "🎬 ETV Win",
      visible: visiblePackages.etvwin
    },
    {
      key: "playboxtv",
      title: "▶ PlayBox",
      visible: visiblePackages.playboxtv && isActivePlan(expiryData?.playboxtv)
    },
    {
      key: "pioneeriptv",
      title: "📡 Pioneer IPTV",
      visible: visiblePackages.pioneeriptv
    },
    {
      key: "railtel",
      title: "🚄 RailTel",
      // Same gating as every other provider: backend only reports this
      // true when the operator has railtelEnabled=1 AND at least one
      // RailTel package mapped to them.
      visible: visiblePackages.railtel
    },
    // {
    //   key: "antiptv",
    //   title: "📺 ANT IPTV",
    //   visible: visiblePackages.antiptv
    // },
    {
      key: "vrplay",
      title: "🎮 VRPLAY",
      visible: visiblePackages.vrplay
    },
    {
      key: "transactions",
      title: "💰 Transactions",
      // Always visible — every customer could have wallet-driven
      // recharge transactions on file regardless of which providers
      // are currently enabled for them.
      visible: true
    }
  ];

  return (
    <>
      <Header />

      <div className="customer-page">

        {loading ? (
          <div className="customer-loading-container">
            <div className="customer-skeleton-card">
              {/* Header Skeleton */}
              <div className="skeleton-header">
                <div className="skeleton-title"></div>
              </div>

              {/* Customer Details Skeleton */}
              <div className="skeleton-details">
                {[...Array(8)].map((_, index) => (
                  <div key={index} className="skeleton-detail-row">
                    <div className="skeleton-label"></div>
                    <div className="skeleton-value"></div>
                  </div>
                ))}
              </div>

              {/* Package Skeleton */}
              <div className="skeleton-package-section">
                <div className="skeleton-package-header">
                  <div className="skeleton-package-title"></div>
                </div>
                <div className="skeleton-package-details">
                  <div className="skeleton-package-row">
                    <div className="skeleton-package-label"></div>
                    <div className="skeleton-package-value"></div>
                  </div>
                  <div className="skeleton-package-row">
                    <div className="skeleton-package-label"></div>
                    <div className="skeleton-package-value"></div>
                  </div>
                </div>
                <div className="skeleton-ott-container">
                  {[...Array(4)].map((_, index) => (
                    <div key={index} className="skeleton-ott-item"></div>
                  ))}
                </div>
              </div>

              {/* Action Buttons Skeleton */}
              <div className="skeleton-actions">
                <div className="skeleton-button-group">
                  <div className="skeleton-button"></div>
                  <div className="skeleton-button"></div>
                </div>
                <div className="skeleton-button-group">
                  <div className="skeleton-button"></div>
                  <div className="skeleton-button"></div>
                </div>
              </div>
            </div>
          </div>
        ) : error ? (
          <p className="error">{error}</p>
        ) : (
          <div className="customer-container">

            {/* CUSTOMER DETAILS CARD */}
            {customer && (
              <div className="customer-profile-card">
                <div className="profile-card-header2">
                  <div className="profile-card-header">
                    <div className="profile-avatar-wrapper">
                      <div className="profile-avatar">
                        <div className="avatar-initials">
                          {customer.name?.charAt(0)}{customer.lastName?.charAt(0)}
                        </div>
                        <div className="avatar-status">
                          <span className={`status-dot ${customer.ExpiryDate && new Date(customer.ExpiryDate) >= new Date() ? 'active' : 'inactive'}`}></span>
                        </div>
                      </div>
                    </div>
                    <div className="profile-title-info">
                      <h2 className="profile-title">{customer.name} {customer.lastName}</h2>
                    </div>
                  </div>
                  <button
                    className="btn-edit-profile"
                    onClick={() => openEditCustomerForm(customer)}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                    </svg>
                    <span className="btn-text-edit-customer">Edit</span>
                  </button>
                </div>

                <div className="profile-details-grid">
                  <div className="detail-item">
                    <div className="detail-info">
                      <label>📞 Phone Number: </label>
                      <p className="detail-value">{customer.MobileNumber}</p>
                    </div>
                  </div>

                  <div className="detail-item">
                    <div className="detail-info">
                      <label>🔑 OTP: </label>
                      <div className="password-field">
                        <span className="password-value">
                          {showUsernamePassword ? customer.otp : "••••••"}
                        </span>
                        <button
                          className="password-toggle-btn-otp"
                          onClick={() => setShowUsernamePassword(!showUsernamePassword)}
                          title={showUsernamePassword ? "Hide OTP" : "Show OTP"}
                        >
                          {showUsernamePassword ? (
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                              <line x1="1" y1="1" x2="23" y2="23" />
                            </svg>
                          ) : (
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                              <circle cx="12" cy="12" r="3" />
                            </svg>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="detail-item">
                    <div className="detail-info">
                      <label>📧 Email Address: </label>
                      <p className="detail-value">{customer.EmailId || 'Not provided'}</p>
                    </div>
                  </div>

                  <div className="detail-item">
                    <div className="detail-info">
                      <label>🏢 Operator: </label>
                      <p className="detail-value">{customer.operatorDetails}</p>
                    </div>
                  </div>
                </div>

                {customer.address && (
                  <div className="profile-address">
                    <div className="address-info">
                      <label>📍 Address: </label>
                      <p>{customer.address}</p>
                    </div>
                  </div>
                )}

                {customer.remarks && (
                  <div className="profile-remarks">
                    <div className="remarks-info">
                      <label>📝 Remarks:</label>
                      <p>{customer.remarks}</p>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Tabs are now ALWAYS rendered, regardless of expiryLoading —
                previously they disappeared entirely during every
                syncPlans() call (i.e. after every single recharge or
                change-plan action), which combined with the full-page
                skeleton on fetchCustomer() made every action feel like
                the whole page had reset, even once the actual tab
                selection itself was preserved correctly underneath. */}
            <div className="provider-tabs">
              {providerTabs
                .filter(tab => tab.visible)
                .map(tab => (
                  <button
                    key={tab.key}
                    className={activeProvider === tab.key ? "active" : ""}
                    onClick={() => selectProviderTab(tab.key)}
                  >
                    {tab.title}
                  </button>
                ))}
            </div>

            {/* Content also stays mounted through a refresh now — a
                small inline spinner overlays the EXISTING (slightly
                stale) content instead of replacing it with a blank
                spinner-only screen. Feels like a quick update instead
                of a reload. */}
            <div className="section" style={{ position: "relative" }}>
              {expiryLoading && (
                <div className="sync-loading-inline-overlay">
                  <div className="sync-spinner sync-spinner--small"></div>
                </div>
              )}

              <div className="plans-container">

                  {(activeProvider === "internet") && (
                    <>
                      <h2 className="plan-title title-internet">🌐 INTERNET</h2>
                      {internetAccounts.length > 1 && (
                        <div className="internet-account-tabs">

                          {internetAccounts.map((item) => (

                            <div
                              key={item.id}
                              className={`internet-account-chip ${selectedInternetAccount === item.id
                                ? "active"
                                : ""
                                }`}
                              onClick={() => loadInternetCustomer(item.id)}
                            >

                              <div className="chip-top">

                                <span className="chip-user">
                                  {item.internet_username}
                                </span>

                                <span
                                  className={`chip-status ${item.status === "Active"
                                    ? "active"
                                    : "expired"
                                    }`}
                                >
                                  {item.status}
                                </span>

                              </div>

                              <div className="chip-bottom">

                                {item.package_name}

                              </div>

                            </div>

                          ))}

                        </div>
                      )}
                      <InternetPlanCard
                        user={user}
                        internetInfo={internetInfo}
                        loading={internetActionLoading || actionLoading === "internet"}
                        // expiryLoading covers the window BEFORE syncPlans()
                        // even gets to calling loadInternetCustomer() (i.e.
                        // while sync_user_plans.php itself is still in
                        // flight) — internetLoading alone doesn't turn true
                        // until after that point, leaving a real gap where
                        // internetInfo is still null but neither flag was
                        // true yet, which is exactly the window the "No
                        // Internet connection linked" state was incorrectly
                        // showing in. Combining both closes it completely.
                        accountLoading={expiryLoading || internetLoading}
                        onRecharge={(isAdvance) => {
                          setInternetRechargeAdvance(isAdvance);
                          setShowInternetRecharge(true);
                        }}
                        onLinkAccount={handleLinkInternetAccount}
                        onRemoveMac={() => setShowRemoveMac(true)}
                        onSessionHistory={() => setShowSessionHistory(true)}
                        onPassword={() => setShowPasswordModal(true)}
                        onChangeVerification={() => setShowVerification(true)}
                        onVerifyAadhaar={() => setShowVerifyAadhaar(true)}
                      />
                      <VerifyAadhaarModal
                        open={showVerifyAadhaar}
                        onClose={() => setShowVerifyAadhaar(false)}
                        internetId={selectedInternetAccount}
                        mobile={internetInfo?.results?.mobile}
                        operatorId={customer?.operatorId}
                        token={token}
                        onSuccess={() => {
                          setShowVerifyAadhaar(false);
                          loadInternetCustomer(selectedInternetAccount);
                          syncPlans();
                        }}
                      />
                      <InternetRechargeModal
                        open={showInternetRecharge}
                        onClose={() => setShowInternetRecharge(false)}
                        internetAccountId={selectedInternetAccount}
                        internetInfo={internetInfo}
                        operatorId={customer?.operatorId}
                        token={token}
                        advance={internetRechargeAdvance}
                        onSuccess={() => {
                          setShowInternetRecharge(false);
                          loadInternetCustomer(selectedInternetAccount);
                          syncPlans();
                        }}
                      />
                      <RemoveMacModal
                        open={showRemoveMac}
                        internetId={selectedInternetAccount}
                        token={token}
                        onClose={() => setShowRemoveMac(false)}
                        onSuccess={() => {
                          setShowRemoveMac(false);
                          syncPlans();
                        }}
                      />
                      <PasswordModal
                        open={showPasswordModal}
                        internetId={selectedInternetAccount}
                        token={token}
                        onClose={() => setShowPasswordModal(false)}
                      />

                      <VerificationModal
                        open={showVerification}
                        internetId={selectedInternetAccount}
                        token={token}
                        username={internetInfo?.results?.username_org}
                        customerName={`${internetInfo?.results?.firstname} ${internetInfo?.results?.lastname}`}
                        onClose={() => setShowVerification(false)}
                        onSuccess={() => {
                          loadInternetCustomer(selectedInternetAccount);
                        }}
                      />
                      <SessionHistoryModal
                        open={showSessionHistory}
                        internetId={selectedInternetAccount}
                        token={token}
                        onClose={() =>
                          setShowSessionHistory(false)
                        }
                      />
                    </>
                  )}

                  {(activeProvider === "dvpl") && (
                    <>
                      <h2 className="plan-title title-internet">📶 DVPL</h2>
                      {dvplAccounts.length > 1 && (
                        <div className="internet-account-tabs">

                          {dvplAccounts.map((item) => (

                            <div
                              key={item.id}
                              className={`internet-account-chip ${selectedDvplAccount === item.id
                                ? "active"
                                : ""
                                }`}
                              onClick={() => loadDvplCustomer(item.id)}
                            >

                              <div className="chip-top">

                                <span className="chip-user">
                                  {item.internet_username}
                                </span>

                                <span
                                  className={`chip-status ${item.status === "Active"
                                    ? "active"
                                    : "expired"
                                    }`}
                                >
                                  {item.status}
                                </span>

                              </div>

                              <div className="chip-bottom">

                                {item.package_name}

                              </div>

                            </div>

                          ))}

                        </div>
                      )}
                      <InternetPlanCard
                        user={user}
                        internetInfo={dvplInfo}
                        loading={dvplActionLoading || actionLoading === "dvpl"}
                        accountLoading={expiryLoading || dvplLoading}
                        providerLabel="DVPL"
                        onRecharge={(isAdvance) => {
                          setDvplRechargeAdvance(isAdvance);
                          setShowDvplRecharge(true);
                        }}
                        onLinkAccount={handleLinkDvplAccount}
                        onRemoveMac={() => setShowDvplRemoveMac(true)}
                        onSessionHistory={() => setShowDvplSessionHistory(true)}
                        onPassword={() => setShowDvplPasswordModal(true)}
                        onChangeVerification={() => setShowDvplVerification(true)}
                        onVerifyAadhaar={() => setShowDvplVerifyAadhaar(true)}
                      />
                      <VerifyAadhaarModal
                        open={showDvplVerifyAadhaar}
                        onClose={() => setShowDvplVerifyAadhaar(false)}
                        internetId={selectedDvplAccount}
                        mobile={dvplInfo?.results?.mobile}
                        operatorId={customer?.operatorId}
                        token={token}
                        onSuccess={() => {
                          setShowDvplVerifyAadhaar(false);
                          loadDvplCustomer(selectedDvplAccount);
                          syncPlans();
                        }}
                      />
                      <InternetRechargeModal
                        open={showDvplRecharge}
                        onClose={() => setShowDvplRecharge(false)}
                        internetAccountId={selectedDvplAccount}
                        internetInfo={dvplInfo}
                        operatorId={customer?.operatorId}
                        token={token}
                        advance={dvplRechargeAdvance}
                        type="dvpl"
                        onSuccess={() => {
                          setShowDvplRecharge(false);
                          loadDvplCustomer(selectedDvplAccount);
                          syncPlans();
                        }}
                      />
                      <RemoveMacModal
                        open={showDvplRemoveMac}
                        internetId={selectedDvplAccount}
                        token={token}
                        onClose={() => setShowDvplRemoveMac(false)}
                        onSuccess={() => {
                          setShowDvplRemoveMac(false);
                          syncPlans();
                        }}
                      />
                      <PasswordModal
                        open={showDvplPasswordModal}
                        internetId={selectedDvplAccount}
                        token={token}
                        onClose={() => setShowDvplPasswordModal(false)}
                      />

                      <VerificationModal
                        open={showDvplVerification}
                        internetId={selectedDvplAccount}
                        token={token}
                        username={dvplInfo?.results?.username_org}
                        customerName={`${dvplInfo?.results?.firstname} ${dvplInfo?.results?.lastname}`}
                        onClose={() => setShowDvplVerification(false)}
                        onSuccess={() => {
                          loadDvplCustomer(selectedDvplAccount);
                        }}
                      />
                      <SessionHistoryModal
                        open={showDvplSessionHistory}
                        internetId={selectedDvplAccount}
                        token={token}
                        onClose={() =>
                          setShowDvplSessionHistory(false)
                        }
                      />
                    </>
                  )}

                  {(activeProvider === "watcho") && (
                    <>
                      <h2 className="plan-title title-watcho">VRPLAY - WATCHO</h2>
                      <PlanCard
                        title="Watcho"
                        type="watcho"
                        data={plansData.watcho}
                        expiry={expiryData.watcho}
                        onRenew={() => handleRenew("watcho")}
                        onChange={() => handleChange("watcho")}
                        loading={actionLoading === "watcho"}
                        cooldownActive={isCooldownActive("watcho")}
                        remainingTime={getRemainingTime("watcho")}
                      />
                    </>
                  )}

                  {(activeProvider === "etvwin") && (
                    <>
                      <h2 className="plan-title title-etvwin">ETVWIN</h2>
                      <PlanCard
                        title="ETVWIN"
                        type="etvwin"
                        data={plansData.etvwin}
                        expiry={expiryData.etvwin}
                        onRenew={() => handleRenew("etvwin")}
                        onChange={() => handleChange("etvwin")}
                        loading={actionLoading === "etvwin"}
                        cooldownActive={isCooldownActive("etvwin")}
                        remainingTime={getRemainingTime("etvwin")}
                      />
                    </>
                  )}

                  {(activeProvider === "playboxtv") && (
                    <>
                      <div className="playbox-ott-section">
                        <h2 className="plan-title title-playboxtv">PLAYBOX TV</h2>
                        <h3 className="playbox-note-text">(Please Note: Playbox TV app is not available in Samsung and LG TV's)</h3>
                      </div>
                      <PlanCard
                        title="Playbox TV"
                        type="playboxtv"
                        data={plansData.playboxtv}
                        expiry={expiryData.playboxtv}
                        onRenew={() => handleRenew("playboxtv")}
                        onChange={() => handleChange("playboxtv")}
                        loading={actionLoading === "playboxtv"}
                        cooldownActive={isCooldownActive("playboxtv")}
                        remainingTime={getRemainingTime("playboxtv")}
                      />
                    </>
                  )}

                  {(activeProvider === "pioneeriptv") && (
                    <>
                      <h2 className="plan-title title-pioneeriptv">PIONEER IPTV</h2>
                      <PioneerPlanCard
                        customer={customer}
                        pioneerInfo={pioneerIptvInfo}
                        pioneerStbs={pioneerStbs}
                        plans={pioneerPlanOptions}
                        loading={actionLoading === "pioneeriptv"}
                        addUserLoading={addUserLoading}
                        addUserError={pioneerAddUserError}
                        onAddUser={openAddPioneerUserDialog}
                        onRecharge={openPioneerRechargePicker}
                        onRemove={handleRemovePioneerStb}
                        removeLoading={pioneerRemoveStbLoading}
                      />
                    </>
                  )}

                  {(activeProvider === "railtel") && (
                    <>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
                        <h2 className="plan-title" style={{ color: "#4a90b8", margin: 0 }}>🚄 RAILTEL</h2>

                        {/* Linking is capped at 2 accounts per customer — the
                            provider's API has no mobile-number search, so
                            accounts have to be entered once when they're
                            created rather than discovered. */}
                        {railtelLinkedAccounts.length < 2 && (
                          !showAddRailtelAccount ? (
                            <button
                              className="railtel-btn railtel-btn--outline"
                              onClick={() => setShowAddRailtelAccount(true)}
                            >
                              + Add RailTel Account
                            </button>
                          ) : (
                            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                              <input
                                type="text"
                                placeholder="RailTel username, e.g. ap.phani87"
                                value={newRailtelUsername}
                                onChange={(e) => setNewRailtelUsername(e.target.value)}
                                disabled={addingRailtelAccount}
                                style={{ padding: "8px 10px" }}
                              />
                              <button
                                className="railtel-btn railtel-btn--primary"
                                onClick={handleAddRailtelAccount}
                                disabled={addingRailtelAccount}
                              >
                                {addingRailtelAccount ? "Linking…" : "Link"}
                              </button>
                              <button
                                className="railtel-btn railtel-btn--outline"
                                onClick={() => { setShowAddRailtelAccount(false); setNewRailtelUsername(""); }}
                                disabled={addingRailtelAccount}
                              >
                                Cancel
                              </button>
                            </div>
                          )
                        )}
                      </div>

                      {railtelLoading ? (
                        <div className="railtel-card">
                          <div className="railtel-card__empty">
                            <div className="railtel-card__empty-icon">🚄</div>
                            <p>Loading RailTel accounts…</p>
                          </div>
                        </div>
                      ) : (
                        <>
                          {railtelSubscribers.length > 0 && (
                            <div className="railtel-account-tabs">
                              {railtelSubscribers.map((sub) => (
                                <div
                                  key={sub.username}
                                  className={`railtel-account-chip ${selectedRailtelSubscriber?.username === sub.username ? "active" : ""}`}
                                >
                                  <div onClick={() => selectRailtelSubscriber(sub)} style={{ cursor: "pointer" }}>
                                    <div className="chip-top">
                                      <span className="chip-user">{sub.username}</span>
                                      <span className={`chip-status ${sub.is_active ? "active" : "expired"}`}>
                                        {sub.is_active ? "Active" : "Expired"}
                                      </span>
                                    </div>
                                    <div className="chip-bottom">{sub.package}</div>
                                  </div>
                                  <button
                                    className="railtel-chip-remove"
                                    title="Remove this RailTel account"
                                    onClick={(e) => { e.stopPropagation(); handleRemoveRailtelAccount(sub.linkedAccountId); }}
                                  >
                                    ✕
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}


                          {railtelSubscribers.length === 0 ? (
                            <div className="railtel-card">
                              <div className="railtel-card__empty">
                                <div className="railtel-card__empty-icon">🚄</div>
                                <p>No RailTel account linked yet for this customer.</p>
                              </div>
                            </div>
                          ) : (
                            <>
                              <RailtelPlanCard
                                subscriber={selectedRailtelSubscriber}
                                isOnline={railtelOnline}
                                onlineLoading={railtelOnlineLoading}
                                refreshLoading={railtelRefreshLoading}
                                onRefresh={refreshRailtelSubscriber}
                                onRecharge={() => setShowRailtelRecharge(true)}
                                onSessionHistory={() => setShowRailtelSessionHistory(true)}
                              />

                              <RailtelRechargeModal
                                open={showRailtelRecharge}
                                onClose={() => setShowRailtelRecharge(false)}
                                username={selectedRailtelSubscriber?.username}
                                packageName={selectedRailtelSubscriber?.package}
                                operatorId={customer?.operatorId}
                                customerId={customer?.id}
                                onSuccess={refreshRailtelSubscriber}
                              />

                              <RailtelSessionHistoryModal
                                open={showRailtelSessionHistory}
                                username={selectedRailtelSubscriber?.username}
                                onClose={() => setShowRailtelSessionHistory(false)}
                              />
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}

                  {(activeProvider === "vrplay") && (
                    <>
                      <h2 className="plan-title title-vrplay">VRPLAY</h2>
                      <PlanCard
                        title="VRPlay"
                        type="vrplay"
                        data={plansData.vrplay}
                        expiry={expiryData.vrplay}
                        onRenew={() => handleRenew("vrplay")}
                        onChange={() => handleChange("vrplay")}
                        onDevices={getDevices}
                        onStelfiberDevices={getStelfiberDevices}
                        loading={actionLoading === "vrplay"}
                        cooldownActive={isCooldownActive("vrplay")}
                        remainingTime={getRemainingTime("vrplay")}
                      />
                    </>
                  )}

                  {(activeProvider === "transactions") && (
                    <CustomerTransactionHistory customerId={customer?.id} />
                  )}

                </div>
              </div>
          </div>
        )}
      </div>

      <ComboPlansModal
        visible={comboModal}
        onClose={() => setComboModal(false)}
        token={token}
        allPlans={allPackDetails}
        userId={customer?.id}
        onSuccess={() => fetchCustomer(true)}
      />

      <ChangeBasePlanModal
        visible={planModal.visible}
        onClose={() => setPlanModal({ visible: false, type: null })}
        userId={customer?.id}
        type={planModal.type}
        currentPlanId={
          planModal.type === "vrplay"
            ? customer?.vrplay_planId
            : planModal.type === "playboxtv"
              ? customer?.playboxtv_planId
              : planModal.type === "antiptv"
                ? customer?.antiptv_planId
                : planModal.type === "pioneeriptv"
                  ? customer?.pioneeriptv_planId
                  : planModal.type === "etvwin"
                    ? customer?.etvwin_planId
                    : customer?.watcho_planId
        }
        slot={planModal.slot}
        token={token}
        onSuccess={() => fetchCustomer(true)}
        allowedPlans={allowedPlans}
        fetchComboOptions={fetchComboOptions}
      />

      <ConfirmModal
        isOpen={confirmModal.open}
        message="Once recharge is successful, it cannot be cancelled or reverted. Please confirm before proceeding."
        onConfirm={confirmRecharge}
        onCancel={() => setConfirmModal({ open: false, type: null })}
      />

      {devicesModalVisible && (
        <DevicesModal
          user={selectedUserForDevices}
          devices={deviceType === "normal" ? devices : stelfiberDevices}
          deviceType={deviceType}
          assignLoading={assignLoading}
          onClose={() => setDevicesModalVisible(false)}
          removeDevice={deviceType === "normal" ? removeDevice : removeStelfiberDevice}
          handleResetDevicesCount={deviceType === "normal" ? handleResetDevicesCount : null}
          fetchAssignableStelfiber={fetchAssignableStelfiber}
          assignDevices={assignDevices}
          showAssign={showAssign}
          setShowAssign={setShowAssign}
          assignSearch={assignSearch}
          setAssignSearch={setAssignSearch}
          assignStelfiberDevice={assignStelfiberDevice}
          assignDevicesLoading={assignLoading}
        />
      )}

      {showEditForm && (
        <div className="modal-overlay">
          <div className="modal-content edit-modal">
            <div className="modal-header">
              <h3>Edit Customer</h3>
              <button className="close-modal" onClick={() => setShowEditForm(false)}>✕</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                {role === "superadmin" && (
                  <div className="form-group">
                    <label>Username</label>
                    <input name="username" placeholder="Username" value={editForm.username} onChange={handleEditChange} />
                  </div>
                )}
                <div className="form-group">
                  <label>Password</label>
                  <div className="password-wrapper">
                    <input
                      name="password"
                      type={showPassword ? "text" : "password"}
                      placeholder="New Password"
                      value={editForm.password}
                      onChange={handleEditChange}
                    />
                    <span
                      className="password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? "👁️" : "👁️‍🗨️"}
                    </span>
                  </div>
                </div>
                <div className="form-group">
                  <label>First Name *</label>
                  <input name="name" placeholder="First Name" value={editForm.name} onChange={handleEditChange} />
                </div>
                <div className="form-group">
                  <label>Last Name *</label>
                  <input name="lastName" placeholder="Last Name" value={editForm.lastName} onChange={handleEditChange} />
                </div>
                {role === "superadmin" && (
                  <div className="form-group">
                    <label>Phone Number *</label>
                    <input name="MobileNumber" placeholder="Phone Number" value={editForm.MobileNumber} onChange={handleEditChange} />
                  </div>
                )}
                <div className="form-group">
                  <label>Email ID</label>
                  <input name="EmailId" placeholder="Email Id" value={editForm.EmailId} onChange={handleEditChange} />
                </div>
                <div className="form-group">
                  <label>Address</label>
                  <input name="address" placeholder="Address" value={editForm.address} onChange={handleEditChange} />
                </div>
                <div className="form-group">
                  <label>Remarks</label>
                  <input name="remarks" placeholder="Remarks" value={editForm.remarks} onChange={handleEditChange} />
                </div>
                <div className="form-group">
                  <label>Operator Details</label>
                  {role !== "operator" ? (
                    <OperatorSearchSelect
                      placeholder="-- Select Operator/Admin --"
                      value={editForm.operatorId}
                      options={
                        // Matches the ORIGINAL rendered <option> text exactly
                        // (which used user.phoneNumber here) — the onChange
                        // handler below independently uses
                        // user.operatorPhoneNumber for the saved
                        // operatorDetails string, same as before this change;
                        // this options list is only for what's shown/searched.
                        role === "admin"
                          ? [
                              {
                                id: Number(user.operatorId),
                                operatorName: user.operatorName,
                                phoneNumber: user.phoneNumber
                              },
                              ...operators
                            ]
                          : operators
                      }
                      onChange={(id) => {
                        const selectedId = id == null ? "" : Number(id);
                        const allOptions =
                          role === "admin"
                            ? [
                              {
                                id: Number(user.operatorId),
                                operatorName: user.operatorName,
                                phoneNumber: user.operatorPhoneNumber
                              },
                              ...operators
                            ]
                            : operators;

                        const selectedOp = allOptions.find(op => op.id === selectedId);

                        setEditForm({
                          ...editForm,
                          operatorId: selectedId,
                          operatorDetails: selectedOp
                            ? `${selectedOp.operatorName} - ${selectedOp.phoneNumber}`
                            : '',
                        });
                      }}
                    />
                  ) : (
                    <input
                      name="operatorDetails"
                      placeholder="Operator Details"
                      value={`${user.operatorName || ''} - ${user.phoneNumber || ''}`}
                      readOnly
                    />
                  )}
                </div>
                {role === "superadmin" && (
                  <div className="form-group">
                    <label>Expiry Date</label>
                    <input
                      type="date"
                      id="ExpiryDate"
                      name="ExpiryDate"
                      value={editForm.ExpiryDate}
                      onChange={handleEditChange}
                      required
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>Autoplay</label>
                  <select name="autoplay" value={editForm.autoplay} onChange={handleEditChange}>
                    <option value="on">Autoplay On</option>
                    <option value="off">Autoplay Off</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button disabled={loading} className="btn btn-primary" onClick={submitEditForm}>
                {loading ? "Updating..." : "Update Customer"}
              </button>
              <button className="btn btn-secondary" onClick={() => setShowEditForm(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <Dialog
        open={showRechargeDialog}
        maxWidth="sm"
        fullWidth
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

          <DialogTitle>

            Pioneer IPTV Recharge

          </DialogTitle>

          <Button

            onClick={() => setShowRechargeDialog(false)}
            style={{ color: "red" }}
          >

            ✕

          </Button>
        </div>

        <DialogContent>

          <Typography sx={{ mb: 2 }}>

            Device :
            {" "}
            {selectedStb?.stb_box}

          </Typography>

          <FormControl fullWidth>

            <InputLabel>

              Package

            </InputLabel>

            <Select

              value={selectedPlan?.id || ""}

              label="Package"

              onChange={(e) => {

                const p = pioneerPlanOptions.find(
                  x => x.id === e.target.value
                );

                setSelectedPlan(p);

              }}

            >

              {pioneerPlanOptions.map(plan =>

                <MenuItem
                  key={plan.id}
                  value={plan.id}
                  sx={{
                    whiteSpace: "normal",
                    alignItems: "flex-start",
                    lineHeight: 1.4,
                    py: 1
                  }}
                >
                  <div style={{ width: "100%", borderBottom: "1px solid #e0e0e0", paddingBottom: 4 }}>
                    <div
                      style={{
                        fontWeight: 600,
                        wordBreak: "break-word"
                      }}
                    >
                      {plan.planName}
                    </div>

                    <div
                      style={{
                        color: "#1976d2",
                        fontSize: 15,
                        marginTop: 4,
                        textAlign: "right",
                      }}
                    >
                      ₹ {plan.planPrice}
                    </div>
                  </div>
                </MenuItem>

              )}

            </Select>

          </FormControl>

          {/* Branch selection — silent auto-select when the operator only
              has one branch assigned; a real picker when they have more
              than one. Nothing shown while still loading, and a clear
              warning if none are assigned at all (recharge is blocked
              server-side either way, but this makes the reason visible
              up front instead of failing after clicking Recharge). */}
          {pioneerBranchesLoading && (
            <Typography sx={{ mt: 2, color: "text.secondary", fontSize: 14 }}>
              Loading branches…
            </Typography>
          )}

          {!pioneerBranchesLoading && pioneerBranches.length > 1 && (
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>Branch</InputLabel>
              <Select
                value={selectedBranch?.id || ""}
                label="Branch"
                onChange={(e) => {
                  const b = pioneerBranches.find(x => x.id === e.target.value);
                  setSelectedBranch(b);
                }}
              >
                {pioneerBranches.map(branch => (
                  <MenuItem key={branch.id} value={branch.id}>
                    {branch.display_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {!pioneerBranchesLoading && pioneerBranches.length === 1 && (
            <Typography sx={{ mt: 2, color: "text.secondary", fontSize: 14 }}>
              Branch: <strong>{pioneerBranches[0].display_name}</strong>
            </Typography>
          )}

          {!pioneerBranchesLoading && pioneerBranches.length === 0 && (
            <Typography sx={{ mt: 2, color: "error.main", fontSize: 14 }}>
              No Pioneer IPTV branch is assigned to this operator yet — recharge will be blocked until your admin assigns one.
            </Typography>
          )}

        </DialogContent>

        <DialogActions>

          <Button

            onClick={() => setShowRechargeDialog(false)}

          >

            Cancel

          </Button>

          <Button
            variant="contained"
            onClick={confirmPioneerRecharge}
            disabled={actionLoading === "pioneeriptv" || pioneerBranchesLoading || !selectedBranch}
          >

            {actionLoading === "pioneeriptv" ? "Processing..." : "Recharge"}


          </Button>

        </DialogActions>

      </Dialog>

      <Dialog
        open={showAddPioneerUserDialog}
        onClose={() => setShowAddPioneerUserDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <DialogTitle>Add Pioneer IPTV Customer</DialogTitle>
          <Button onClick={() => setShowAddPioneerUserDialog(false)} style={{ color: "red" }}>
            ✕
          </Button>
        </div>
 
        <DialogContent>
          <Typography sx={{ mb: 2, color: "text.secondary", fontSize: 14 }}>
            This creates a new Pioneer IPTV account for {customer?.name} {customer?.lastName}.
          </Typography>

          {pioneerBranchesLoading && (
            <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
              Loading branches…
            </Typography>
          )}

          {!pioneerBranchesLoading && pioneerBranches.length > 1 && (
            <FormControl fullWidth>
              <InputLabel>Branch</InputLabel>
              <Select
                value={selectedBranch?.id || ""}
                label="Branch"
                onChange={(e) => {
                  const b = pioneerBranches.find(x => x.id === e.target.value);
                  setSelectedBranch(b);
                }}
              >
                {pioneerBranches.map(branch => (
                  <MenuItem key={branch.id} value={branch.id}>
                    {branch.display_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {!pioneerBranchesLoading && pioneerBranches.length === 1 && (
            <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
              Branch: <strong>{pioneerBranches[0].display_name}</strong>
            </Typography>
          )}

          {!pioneerBranchesLoading && pioneerBranches.length === 0 && (
            <Typography sx={{ color: "error.main", fontSize: 14 }}>
              No Pioneer IPTV branch is assigned to this operator yet — creating an account will
              be blocked until your admin assigns one.
            </Typography>
          )}

          {pioneerAddUserError && (
            <Typography sx={{ mt: 2, color: "error.main", fontSize: 14 }}>
              {pioneerAddUserError}
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setShowAddPioneerUserDialog(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleAddPioneerUser}
            disabled={addUserLoading || pioneerBranchesLoading || !selectedBranch}
          >
            {addUserLoading ? "Creating..." : "Create Account"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};


function DevicesModal({
  user,
  devices,
  deviceType,
  assignLoading,
  onClose,
  removeDevice,
  handleResetDevicesCount,
  fetchAssignableStelfiber,
  assignDevices,
  showAssign,
  setShowAssign,
  assignSearch,
  setAssignSearch,
  assignStelfiberDevice,
  assignDevicesLoading
}) {
  if (!user) return null;

  return (
    <>
      <div className="devices-modal-overlay">
        <div className="devices-modal-container">
          <div className="devices-modal-header">
            <div className="devices-modal-title-section">
              <h2 className="devices-modal-title">Device Management</h2>
              <span className={`devices-modal-type-badge ${deviceType}`}>
                {deviceType === "stelfiber" ? "Stel Fiber" : "Standard Devices"}
              </span>
            </div>
            <button className="devices-modal-close" onClick={onClose}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>
          </div>

          <div className="devices-modal-body">
            <div className="devices-user-info">
              <div className="devices-user-details">
                <h3 className="devices-user-name">{user.name || user.username}</h3>
                <p className="devices-user-username">@{user.username}</p>
              </div>
            </div>

            {deviceType === "stelfiber" && (
              <button
                className="devices-assign-btn"
                disabled={assignLoading}
                onClick={fetchAssignableStelfiber}
              >
                {assignLoading ? (
                  <>
                    <span className="devices-spinner-small"></span>
                    Loading...
                  </>
                ) : (
                  <>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 4V16M4 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    Assign New Device
                  </>
                )}
              </button>
            )}

            <div className="devices-table-wrapper">
              <table className="devices-table">
                <thead>
                  <tr>
                    <th>Device Name</th>
                    <th>Added Date</th>
                    <th>Last Seen</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {devices.length > 0 ? (
                    devices.map(d => (
                      <tr key={d.id} className="devices-table-row">
                        <td className="devices-device-name">
                          <div className="devices-device-info">
                            <span>{d.name || d.device_name || 'Unknown Device'}</span>
                          </div>
                        </td>
                        <td className="devices-device-date">
                          {d.createdAt || d.added_date || 'N/A'}
                        </td>
                        <td className="devices-device-last-seen">
                          {d.lastSeen || 'N/A'}
                        </td>
                        <td className="devices-device-action">
                          <button
                            className="devices-remove-btn"
                            onClick={() => removeDevice(user.id, d.id)}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="devices-empty-state">
                        <div className="devices-empty-content">
                          <div className="devices-empty-icon">📭</div>
                          <p className="devices-empty-text">No devices found</p>
                          {handleResetDevicesCount && (
                            <button
                              className="devices-reset-btn"
                              onClick={() => handleResetDevicesCount(user.id)}
                            >
                              Reset Device Count
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {devices.length > 0 && (
              <div className="devices-footer">
                <div className="devices-stats">
                  <span className="devices-stats-label">Total Devices:</span>
                  <span className="devices-stats-count">{devices.length}</span>
                </div>
                {handleResetDevicesCount && (
                  <button
                    className="devices-reset-count-btn"
                    onClick={() => handleResetDevicesCount(user.id)}
                  >
                    Reset Count
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Assign Device Modal */}
      {showAssign && (
        <div className="assign-device-modal-overlay">
          <div className="assign-device-modal-container">
            <div className="assign-device-modal-header">
              <h3 className="assign-device-modal-title">Assign Stel Fiber Device</h3>
              <button
                className="assign-device-modal-close"
                onClick={() => setShowAssign(false)}
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>
            </div>

            <div className="assign-device-modal-body">
              <div className="assign-device-search-wrapper">
                <input
                  autoFocus
                  className="assign-device-search"
                  placeholder="Search by device name or MAC address..."
                  value={assignSearch}
                  onChange={(e) => setAssignSearch(e.target.value)}
                />
                <div className="assign-device-search-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </div>
              </div>

              <div className="assign-device-list">
                {assignDevices && assignDevices.length > 0 ? (
                  assignDevices
                    .filter(d =>
                      `${d.device_name} ${d.device_mac}`
                        .toLowerCase()
                        .includes(assignSearch.toLowerCase())
                    ).length > 0 ? (
                    assignDevices
                      .filter(d =>
                        `${d.device_name} ${d.device_mac}`
                          .toLowerCase()
                          .includes(assignSearch.toLowerCase())
                      )
                      .map(d => (
                        <div key={d.id} className="assign-device-item">
                          <div className="assign-device-info">
                            <div className="assign-device-icon">📡</div>
                            <div className="assign-device-details">
                              <div className="assign-device-name">
                                {d.device_name || 'Unnamed Device'}
                              </div>
                              <div className="assign-device-mac">
                                {d.device_mac}
                              </div>
                            </div>
                          </div>
                          <button
                            className="assign-device-submit-btn"
                            disabled={assignDevicesLoading}
                            onClick={() => assignStelfiberDevice(d.id)}
                          >
                            {assignDevicesLoading ? "Assigning..." : "Assign"}
                          </button>
                        </div>
                      ))
                  ) : (
                    <div className="assign-device-empty">
                      <div className="assign-device-empty-icon">🔍</div>
                      <p>No devices match your search</p>
                    </div>
                  )
                ) : (
                  <div className="assign-device-empty">
                    <div className="assign-device-empty-icon">📡</div>
                    <p>No available devices found</p>
                  </div>
                )}
              </div>
            </div>

            <div className="assign-device-modal-footer">
              <button
                className="assign-device-cancel-btn"
                onClick={() => setShowAssign(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}


export default Customer;
